import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import StripePaymentResult from './StripePaymentResult';
import { LinearProgress } from '@mui/material';
import { useInvoice } from '../../hooks/useInvoice';
import { getPublicKey } from './utils';
var StripePaymentResultPage = function () {
    var i18n = useTranslation().i18n;
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var _b = useInvoice(id), loading = _b.loading, invoice = _b.invoice;
    if (!invoice || loading)
        return React.createElement(LinearProgress, null);
    return (React.createElement(Elements, { stripe: loadStripe(getPublicKey(invoice.roaster)), options: {
            locale: i18n.language,
        } },
        React.createElement(StripePaymentResult, { invoiceId: invoice.id })));
};
export default StripePaymentResultPage;
